export type ProductsReportType = 'COMPANY' | 'BRAND' | 'CATEGORY';
export const PRODUCT_REPORT_SIZE = 4;
export const productsReportTypes: ProductsReportType[] = [
  'COMPANY',
  'CATEGORY',
  'BRAND',
];
